<template>
	<div class="fill-height mt-3">
		<!-- changeStatusDialog -->
		<v-dialog v-model="changeStatusDialog" width="400">
			<v-card class="rounded-lg pa-1">
				<v-card-title class="d-flex w-100 ms-0 py-1">
					<span class="title"> Change status project </span>
				</v-card-title>
			
				<v-card-text class="py-1">
					Are you sure you want to change the project status?
				</v-card-text>
				<v-card-actions>
					<v-spacer/>

					<v-btn
						type="submit"
						color="green-color white--text"
						:loading="submitLoading"
						:disabled="submitLoading"
						@click="changeStatus()"
						class="text-none rounded-lg"
					>
						Yes
					</v-btn>
					<v-btn
						@click="changeStatusDialog = false"
						:disabled="submitLoading"
						class="text-none rounded-lg"
						color="alert-color white--text"
					>
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- dialog add edit -->
		<v-dialog width="600" v-model="dialog" >
			<v-card class="rounded-lg pa-1">
				<v-card-title class="py-3">
					<span class="title"> {{ projectId ? 'Edit project' : 'Add new project' }} </span>
				</v-card-title>

				<v-card-text class="pt-3" >
					<v-row class="pt-0">
						<!-- name -->
						<v-col cols="6" class="pt-0 pb-1 px-1">
							<v-text-field	
								v-model="dialogData.projectName"
								label= 'Project name'
								solo
								:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
								dense
								:loading="submitLoading"
								filled
								hide-details
								class="rounded-lg input"
								prepend-icon="mdi-application-brackets "
							></v-text-field>
						</v-col>

						<!-- category -->
						<v-col cols="6" class="pt-0 pb-1 px-1">
							<v-autocomplete
								v-model="dialogData.category"
								:items="categories"
								item-text="name"
								item-value="id"
								label='category'
								dense
								rows="1"
								auto-grow
								no-resize
								:loading="submitLoading"
								filled
								hide-details
								class="rounded-lg input"
								prepend-icon="mdi-book-variant "
								solo
								:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
							>
							</v-autocomplete>
						</v-col>

						<v-col cols="6" align-self="center" class="pt-0 pb-1 px-1">
							<v-checkbox
								v-model="dialogData.checkbox"
								label="Is Active"
								class="mt-0 text--color"
								hide-details
								:disabled="submitLoading"
							></v-checkbox>
						</v-col>

						<!-- keywords -->
						<v-col cols="6" class="pt-0 pb-1 px-1">
							<v-autocomplete
								v-model="dialogData.keywords"
								:items="keywords"
								item-text="name"
								item-value="id"
								label='Keywords'
								solo
								:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
								dense
								rows="1"
								auto-grow
								no-resize
								:loading="submitLoading"
								filled
								hide-details
								class="rounded-lg input"
								prepend-icon="mdi-book-variant"
								multiple
							></v-autocomplete>
						</v-col>

						<!-- team -->
						<v-col cols="12" class="pt-0 pb-1 px-1">
							<v-icon large> mdi-microsoft-teams  </v-icon>
							<span class="fw-4 fs-15"> Team </span>
							<bee-handy-smart-table
								:items="teamsProject"
								:headers="headersTeam"
								v-model="tableInputsTeam"
								ref="tableTeam"
								dense
								zebra
								:show-add-row="!submitLoading"
								height="auto"
								class="mt-2"
								:reset-edit.sync="resetEditTeam"
								@keypress.enter="!isEditTeam ? addMember() : editMember()"
								table-class="rounded-lg"
								editable-rows
								hide-no-data-area
								:items-per-page="-1"
							>
								<!-- change username to name when endpoint ready -->
								<template v-slot:input.userId="{ on, attr }" >
									
									<v-autocomplete
										:items="usersWithoutPag"
										:item-text="(item) => `${item.employee.arabicFirstName}` + ' ' + `${item.employee.arabicLastName}`"
										item-value="id"
										dense
										v-on="on"
										v-bind="attr"
									/>
								</template>

								<template v-slot:input.roleId="{ on, attr }" >
									<v-autocomplete
										:items="rolesInProject"
										item-text="name"
										item-value="id"
										dense
										v-on="on"
										v-bind="attr"
									/>
								</template>
								<template v-slot:input.isActive="{ on, attr }" >
									<!-- <v-autocomplete
										:items="[{ id:0, name: 'active' }]"
										item-text="name"
										item-value="id"
										dense
										v-on="on"
										v-bind="attr"
									/> -->
									<v-switch  
										v-model="tableInputsTeam.isActive"
										v-on="on"
										v-bind="attr" 
										:true-value="true"
									/>
								</template>
								<template v-slot:input.teamCoordinator="{ on, attr }">
									<v-checkbox 
										v-model="tableInputsTeam.teamCoordinator"
										v-on="on"
										v-bind="attr"
										:false-value="false"
										:true-value="true"
									/>
									<!-- {{ value ? 'Yes' : 'No' }} -->
								</template>
								<template v-slot:item.actions="{ index }" >
									<div class="d-flex">
										<!-- <v-switch
											v-model.number="item.status"
											label=""
											dense
											hide-details
											class="mt-0"
										/> -->

										<v-btn
											@click="
												$refs.tableTeam.resetInputs(); 
												$refs.tableTeam.activeEditForRow(index); 
												setRowTeam({ index })
											"
											icon
											color="edit-color"
											:disabled="submitLoading"
										>
											<v-icon> mdi-pencil </v-icon>
										</v-btn>

										<v-btn 
											@click="isSearch = true, 
											deleteMember({ index })" 
											icon 
											color="alert-color"
											:disabled="submitLoading"
										>
											<v-icon> mdi-delete </v-icon>
										</v-btn>
									</div>
								</template>

								<!-- no-input action -->
								<template v-slot:no-input.actions>
									<div class="d-flex justify-center">
										<v-btn
											icon
											small
											color="success"
											@click="isEditTeam ? editMember() : addMember()"
										>
											<v-icon>
												mdi-check-circle-outline
											</v-icon>
										</v-btn>
									</div>
								</template>
							</bee-handy-smart-table>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer/>

					<v-btn
						type="submit"
						color="green-color white--text"
						:loading="submitLoading"
						:disabled="submitLoading || !dialogData.projectName"
						class="text-none rounded-lg"
						@click="isSearch = true; createOrEditProject()"
					>
						Save
					</v-btn>
					<v-btn
						@click="dialog = false"
						:disabled="submitLoading"
						class="text-none rounded-lg"
						color="alert-color white--text"
					>
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- delete dialog -->
		<v-dialog v-model="deleteDialog" width="400">
			<v-card class="rounded-lg pa-1">
				<v-card-title class="d-flex w-100 ms-0 py-1">
					<span class="title"> Delete project </span>
				</v-card-title>
			
				<v-card-text class="py-1">
					Are you sure you want to delete this project?
				</v-card-text>
				<v-card-actions>
					<v-spacer/>

					<v-btn
						type="submit"
						color="green-color white--text"
						:loading="submitLoading"
						:disabled="submitLoading"
						@click="isSearch = true; deleteProject()"
						class="text-none rounded-lg"
					>
						Yes
					</v-btn>
					<v-btn
						@click="deleteDialog = false"
						:disabled="submitLoading"
						class="text-none rounded-lg"
						color="alert-color white--text"
					>
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- add new category dialog -->
		<!-- <v-dialog v-model="categoryDialog" width="400">
			<v-card class="rounded-lg ">
				<v-card-title class="pt-3 pb-0">
					<span class="title"> Add new category </span>
				</v-card-title>

				<v-card-text class="pt-2 pb-1">
					<v-text-field
						v-model="categoryName"
						label="Name"
						dense
						outlined
						filled
						hide-details="auto"
						:disabled="submitLoading"
						class="rounded-lg"
					/>
				</v-card-text>

				<v-card-actions>
					<v-spacer/>
					<v-btn
						color="green-color white--text"
						:loading="submitLoading"
						@click="createCategory()"
						class="text-none rounded-lg"
					>
						Save
					</v-btn>

					<v-btn
						@click="categoryDialog = false"
						:disabled="submitLoading"
						class="text-none rounded-lg"
						color="alert-color white--text"
					>
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog> -->

		<v-row align="center" class="mb-2">
			<v-col cols="2" class="px-1">
				<v-autocomplete
					v-model="categoryIds"
					:items="categories"
					item-value="id"
					item-text="name"
					label="Categories"
					dense
					solo
					:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
					filled
					hide-details
					multiple
					clearable
					:disabled="loading"
					class="input rounded-lg"
				>
					<template v-slot:selection="{ item, index }">
						<span v-if="index === 0" class="me-1">{{ item.name }}</span>
						<span
							v-if="index === 1"
							class="text--color text-caption"
						>
							(+{{ categoryIds.length - 1 }})
						</span>
					</template>  
				</v-autocomplete>
			</v-col>

			<v-divider vertical class="mx-2 my-2" />

			<v-col cols="3" class="px-1 d-flex" align-self="center">
				<!-- change username to name when endpoint ready -->
				<v-checkbox 
					v-model="allUsers" 
					label="All" 
					class="me-3 my-0 d-flex align-center" 
					hide-details 
					:disabled="loading"
				/>
				<v-autocomplete
					v-model="userId"
					:items="usersWithoutPag"
					:item-text="(item) => `${item.employee.arabicFirstName}` + ' ' + `${item.employee.arabicLastName}`"
					item-value="id"
					label="Employee"
					dense
					filled
					hide-details
					multiple
					clearable
					:loading="userLoading"
					:disabled="loading"
					solo
					:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
					class="input rounded-lg"
				>
					<template v-slot:selection="{ item, index }">
						<span v-if="index === 0" class="me-1">
							{{ item.employee.arabicFirstName + '  ' + item.employee.arabicLastName }}
						</span>
						<span
							v-if="index === 1"
							class="text--color text-caption"
						>
							(+{{ userId.length - 1 }})
						</span>
					</template> 
				</v-autocomplete>
			</v-col>

			<v-divider vertical class="mx-2 my-2" />
			
			<v-col cols="auto" class="px-1">
				<v-btn-toggle
					v-model="isActive"
					mandatory
					dense
					class="rounded-lg"
					color="primary"
					@change="isSearch = true; fetchAll()"
				>
					<v-btn  :disabled="loading" class="text-none">All</v-btn>
					<v-btn :disabled="loading" class="text-none">Active</v-btn>
					<v-btn  :disabled="loading" class="text-none">Deactivated</v-btn>
				</v-btn-toggle>
			</v-col>

			<!-- search input -->
			<v-col cols="auto" class="px-1">
				<v-text-field
					v-model="textSearch"
					label="Search"
					append-icon="mdi-magnify" 
					filled
					hide-details
					dense
					@keypress.enter="isSearch = true; fetchAll()"
					:disabled="loading"
					solo
					:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
					class="input rounded-lg"
				/>
			</v-col>
			<v-spacer />
			<v-col cols="auto" class="d-flex justify-end py-0 px-0" style="">
				<v-btn
					@click="isSearch = true; fetchAll()"
					color="dark-blue"
					class="rounded-lg white--text text-none mx-1"
					:loading="loading"
				>	
					Search
				</v-btn>	

				<v-btn
					@click="reset(); isSearch = true; fetchAll()"
					color="alert-color"
					class="rounded-lg white--text text-none"
					:disabled="loading"
				>
					Cancel
				</v-btn>	
			</v-col>
			<v-divider vertical class="mx-1 my-3" />
			<v-col cols="auto" class="d-flex justify-end py-0 ps-2" style="">
				<v-btn
					color="success-light white--text"
					class="text-none rounded-lg"
					@click="reset(); dialog = true"
					:disabled="loading"
				>	
					<v-icon> mdi-plus </v-icon>
					Add
				</v-btn>	
			</v-col>

		</v-row>
		<!-- table -->
		<bee-handy-table
			ref="table"
			:headers="headers"
			:items="[]"
			:loading="loading"
			:data-table-props="{
				disableSort: true,
				noDataText: ''
			}"
			zebra
			table-class="elevation-0"
			fixed-header
			:height="$vuetify.breakpoint.height - 265"
			:options-scroll.sync="optionsScroll"
			pagination-on-scroll
			pagination-on-scroll-server-items
			:pagination-on-scroll-auto-reset-shown="false"
			:server-items-length="serverItemsLength"
			@pagination-on-scroll:reach-last-row="fetchAll"
			:items-per-page="20"
			class="mt-0"
		>
			<template v-slot:item.isActive="{ value }">
				<v-chip small :color="value ? 'green-light green-color--text' : 'alert-color--text red-light'">
					{{ value === true ? 'Activated' : 'Deactivated' }}
				</v-chip>
			</template>
			<template v-slot:item.actions="{ item }">
				<div class="d-flex justify-end">
					<v-switch
						v-model="item.isActive"
						readonly
						dense
						hide-details
						class="ma-0"
						@click="projectId = item.id; changeStatusDialog = true"
						color="dark-blue"
						:disabled="loading"
					></v-switch>

					<v-btn
						color="edit-color"
						icon
						class="px-0"
						@click="projectId = item.id; myItem = item; dialog = true"
						:disabled="loading"
					>
						<v-icon> mdi-pencil </v-icon>
					</v-btn>
					
					<v-btn
						color="alert-color"
						icon
						class="px-0"
						:to="{
							name: 'one-project',
							params: {
								id: item.id
							}
						}"
						:disabled="loading"
					>
						<v-icon
							color="alert-color"
						>
							mdi-chart-bar 
						</v-icon>
					</v-btn>

					<!-- <v-btn
						color="success"
						icon
						class="px-0"
						:to="{
							name: 'features-page',
							params: {
								id: item.id
							}
						}"
						:disabled="loading"
					>
						<v-icon
							color="success"
						>
							mdi-star-circle-outline 
						</v-icon>
					</v-btn> -->

					<v-btn 
						icon 
						color="alert-color" 
						@click="projectId = item.id; deleteDialog = true"
						:disabled="loading"
					>
						<v-icon>
							mdi-delete
						</v-icon>
					</v-btn>
				</div>
			</template>
		</bee-handy-table>

    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapState } from 'vuex'
export default {
	data () {
		return {
			textSearch: null,
			tableInputs: {
				teamCoordinator: false
			},
			entries: [],
			dialog: false,
			deleteDialog: false,
			resetInputsFocus: false,
			resetEdit: false,
			isEditItem: false,
			loading: false,
			submitLoading: false,
			name: '',
			category: '',
			active: false,
			projectId: null,
	
			// projects: ['Pos', 'Edunix', 'Emeraled'],
			// categories: ['One', 'Two'],
			dialogData: {
				projectName: null,
				category: null,
				checkbox: true,
				keywords: [],
				time: 0,
				numOfTask: 0
				// situation: false
			},
			tableInputsTeam: {},
			optionsScroll: {},
			serverItemsLength: 0,
			// categoryDialog: false,
			// categoryName: null,
			status: [
				{
					name: 'Active',
					id: null
				},
				{
					name: 'UnActive',
					id: 1
				}
			],
			isActive: 1,
			changeStatusDialog: false,
			isSearch: false,
			categoryIds: [], 
			userId: [],
			NonDeleted: true,
			isEditTeam: false,
			rowEditIndexTeam: null,
			resetEditTeam: null,
			allProjects: [],
			myItem: {},
			teamsProject: [],
			allUsers: false,
			userLoading: false
		}
	},
	watch: {
		dialog (val) {
			if (val) {
				if (this.projectId !== null) {
					const item = this.allProjects.find(c => c.id === this.myItem.id)
					this.dialogData.projectName = this.myItem?.name
					this.dialogData.category = this.myItem?.categoryId
					this.dialogData.checkbox = this.myItem?.isActive
					this.teamsProject = this.myItem?.projectTeam
				}
			} else {
				this.projectId = null
				this.teamsProject = []
				// this.teamsProject = []
				this.myItem = null
			}
		},

		allUsers (val) {	
			this.userId = []
			this.userLoading = true
			this.$store.dispatch('users/fetchUsersWithoutPag', { isActiveOnly: !val }).finally(() => {
				this.userLoading = false
			})
		} 
		
	},
	computed: {
		contextMenuItems () {
			return [
				{ title: 'Edit', icon: 'mdi-pencil', iconColor: 'edit-color', event: 'edit', class: 'edit-color--text' },
				{ title: 'Delete', icon: 'mdi-delete', iconColor: 'alert-color', event: 'delete', class: 'alert-color--text' }
			]
		},

		...mapState({
			categories: state => state.categories.categories,
			allEmployees: state => state.users.allEmployees,
			employees: state => state.users?.employees,
			rolesInProject: state => state.rolesInProject.rolesInProject,
			usersWithoutPag: state => state.users.usersWithoutPag,
			keywords: state => state.keywords.keywords
		}),
		
		...mapGetters({
			getProjectById: 'projects/getProjectById',
			getCategoryById: 'categories/getCategoryById',
			getRoleById: 'rolesInProject/getRoleById',
			// getUserById: 'users/getUserById',
			getUserByEmployeeId: 'users/getUserByEmployeeId'
		}),
		
		usersWithName () {
			return this.usersWithoutPag.map(c => ({ 
				...c, 
				name: this.usersWithoutPag.find(g => g.id === c.id).employeeId?.arabicFirstName + ' ' + this.usersWithoutPag.find(g => g.id === c.id).employeeId?.arabicLastName
			}))
		},
		isActiveProject () {
			if (this.isActive === 0) {
				return null
			} else if (this.isActive === 1) {
				return true
			} else if (this.isActive === 2) {
				return false
			}
			return this.isActive
		},

		headers () {
			const headers = [
				// {
				// 	text: '#',
				// 	name: 'serial',
				// 	value: 'id'
				// 	// setValueExpr: val => this.allProjects?.map(c => c.id).indexOf(val) + 1
				// },
				{
					text: 'Project name',
					name: 'name',
					value: 'name'
				},
				{
					text: 'Category',
					name: 'categoryId',
					value: 'categoryId',
					setValueExpr: val => this.getCategoryById(val)?.name
				},
				{
					text: 'Last update',
					name: 'lastUpdate',
					value: 'lastUpdate',
					noNotAvailableText: true,
					setValueExpr: val => val !== null ? moment(val).format('YYYY-MM-DD') : '-'
				},
				{
					text: 'Time spent (h)',
					name: 'time-spent',
					value: 'spentTime',
					setValueExpr: val => val > 0 ? (val / 60).toFixed(2) : '-'
				},
				{
					text: 'Tasks',
					name: 'tasks',
					value: 'numOfTask'
				},
				{
					text: 'Situation',
					name: 'isActive',
					value: 'isActive',
					width: '5%'
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					class: 'text-end',
					width: '10%'
				}
			]
			return headers
		},
		headersTeam () {
			return [
				{
					text: 'Name',
					name: 'userId',
					value: 'userId',
					setValueExpr: val => {
						const employee = this.usersWithoutPag.find(c => c.id === val)?.employee
						return employee?.arabicFirstName + ' ' + employee?.arabicLastName
					}
				},
				{
					text: 'role',
					name: 'roleId',
					value: 'roleId',
					setValueExpr: val => this.getRoleById(val)?.name
				},
				{
					text: 'IsActive',
					name: 'isActive',
					value: 'isActive',
					setValueExpr: val => val === true ? 'Active' : 'Deactivated'
				},
				{
					text: 'is leader',
					name: 'teamCoordinator',
					value: 'teamCoordinator',
					setValueExpr: val => val === true ? 'Yes' : 'No',
					type: 'Boolean'
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					noInput: true
				}
			]
		}
	},
	methods: {
		edit (item) {
			// this.dialogData.projectName = item.name
			// this.dialogData.category = item?.categories.id	
			// this.tableInputsTeam = item?.projectTeamIds
		},
		setRowIndex (rowData) {
			this.rowEditIndex = rowData.index
			this.isEditItem = true
		},
		deleteItem ({ index }) {
			this.resetEdit = true
			this.isEditItem = false
			this.entries.splice(index, 1)
		},
		editItem () {
			this.entries[this.rowEditIndex].no = this.tableInputs.no
			this.entries[this.rowEditIndex].project = this.tableInputs.project
			this.entries[this.rowEditIndex].taskContent = this.tableInputs.taskContent
			this.entries[this.rowEditIndex].time = this.tableInputs.time
			this.entries[this.rowEditIndex].tag = this.tableInputs.tag

			this.resetEdit = true
			this.resetTableInputs()
			this.tableInputs.teamCoordinator = false
			this.isEditItem = false
			this.resetInputsFocus = true
		},

		createOrEditProject () {
			this.submitLoading = true
			const actionName = this.projectId ? 'update' : 'create'
			this.$store.dispatch(`projects/${actionName}`, { 
				name: this.dialogData.projectName, 
				categoryId: this.dialogData.category,
				isActive: this.dialogData.checkbox, 
				numOfTask: this.dialogData.numOfTask,
				spentTime: this.dialogData.spentTime,
				keywordIds: this.dialogData.keywords ? this.dialogData.keywords : [],
				projectTeams: this.teamsProject.map(c => ({ ...c, teamCoordinator: Boolean(c.teamCoordinator), isActive: c.isActive ? c.isActive : false })),
				id: actionName === 'update' ? this.projectId : null,
				lastUpdate: moment()
			}).then(() => {
				this.isSearch = true
				// this.$refs.table.resetShownRows()
				this.fetchAll()
			}).finally(() => {
				this.submitLoading = false
				this.projectId = null
				this.dialog = false
			})
		},

		fetchAll (newOptionsScroll) {
			let page = 1
			if (newOptionsScroll) page = newOptionsScroll.page;

			this.loading = true
			this.$store.dispatch('projects/fetchAll', { 
				CategoryIds: this.categoryIds,
				UserId: this.userId.length ? this.userId : [],
				IsActive: this.isActiveProject,
				Page: page, 
				PerPage: 20,
				NonDeleted: true,
				name: this.textSearch
			}).then(({ data, total }) => {
				if (this.isSearch === true) {
					console.log(',l')
					this.$refs.table.resetShownRows()
					// this.isSearch = false
				}
				this.$refs.table.addScrollItems(data)
				this.allProjects = data
			
				this.serverItemsLength = total;
			}).finally(() => {
				this.loading = false
				this.isSearch = false
			})
		},

		reset () {
			this.isSearch = false
			this.projectId = null
			this.dialogData.projectName = null
			this.dialogData.category = null
			this.dialogData.keywords = null
			this.teamsProject = []
			this.tableInputs.teamCoordinator = false
			this.textSearch = null
			this.tableInputsTeam = {}
			this.categoryIds = []
			this.userId = []
			this.isActive = 0
		},

		changeStatus () {
			this.submitLoading = true
			this.$store.dispatch('projects/updateStateProject', { id: this.projectId }).finally(() => {
				this.submitLoading = false
				this.changeStatusDialog = false
				this.isSearch = true
				this.$refs.table.resetShownRows()
				this.fetchAll()
			})
		},

		addMember () {
			this.teamsProject?.push({
				...this.tableInputsTeam,
				id: Math.random(),
				projectId: this.projectId
			})
			this.$refs.tableTeam.resetInputs()
			this.$refs.tableTeam.resetInputsFocus()	
		},

		setRowTeam (rowData) {
			this.rowEditIndexTeam = rowData.index
			this.isEditTeam = true
			this.$nextTick(() => {
				this.$refs.tableTeam.resetInputsFocus()
				this.tableInputs.teamCoordinator = false
			})
		},

		editMember () {
			this.teamsProject[this.rowEditIndexTeam].userId = this.tableInputsTeam.userId
			this.teamsProject[this.rowEditIndexTeam].roleId = this.tableInputsTeam.roleId
			this.teamsProject[this.rowEditIndexTeam].isActive = this.tableInputsTeam.isActive
			this.teamsProject[this.rowEditIndexTeam].projectId = this.projectId
			this.teamsProject[this.rowEditIndexTeam].teamCoordinator = this.tableInputsTeam.teamCoordinator

			this.resetEditTeam = true
			this.$refs.tableTeam.resetEdit()
			this.isEditTeam = false
			this.$refs.tableTeam.resetInputsFocus()
			this.tableInputs.teamCoordinator = false
		},

		deleteMember ({ index }) {
			this.teamsProject.splice(index, 1)
		},

		deleteProject () {
			this.submitLoading = true
			this.$store.dispatch('projects/delete', { id: this.projectId }).then(() => {
				this.deleteDialog = false
				this.isSearch = true
				this.fetchAll()
			}).finally(() => {
				this.submitLoading = false
			})
		}
	},

	created () {
		this.isSearch = true
		if (this.$route.query.categoryId) {
			this.categoryIds.push(
				this.$route.query.categoryId
			)
		}
		Promise.all([
			this.$store.dispatch('users/fetchAll', {}).then(() => {
				this.$store.dispatch('users/fetchAllEmployees')
			}),
			!this.keywords.length ? this.$store.dispatch('keywords/fetchAll') : null,
			!this.categories.length ? this.$store.dispatch('categories/fetchAll') : null,
			this.fetchAll(),
			!this.rolesInProject.length ? this.$store.dispatch('rolesInProject/fetchAll') : null,
			!this.usersWithoutPag.length ? this.$store.dispatch('users/fetchUsersWithoutPag', { isActiveOnly: true }) : null
		])
	}
}
</script>

<style scoped>
.w-100 {
	width: 100%;
}
</style>
<style>
label.v-label.theme--light {
	color: black !important
}
</style>

<style>
input[type="time"]::-webkit-calendar-picker-indicator { display: none; }
.bee-handy-table--zebra-color:nth-of-type(odd) {
	background-color: #f5ecc966
}
td {
	font-family: 'Urbanist' !important;
}
input:focus {
	border: none !important;
}

</style>

<style>
* {
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

</style>
